<template>
  <div class="cart-guest-checkout-interruption">
    <div class="cart-guest-checkout-interruption__col cart-guest-checkout-interruption__col--left">
      <span class="cart-guest-checkout-interruption__title">{{ $t('cart.interruptStep.title') }}</span>
      <span class="cart-guest-checkout-interruption__subtitle">{{ $t('cart.interruptStep.subtitle') }}</span>
      <button class="cart-guest-checkout-interruption__signin button button--primary" @click="onLoginClick">{{ $t('cart.empty.signIn') }}</button>
      <button class="cart-guest-checkout-interruption__signup button" @click="onLoginClick">{{ $t('cart.interruptStep.signUp') }}</button>
    </div>

    <div class="cart-guest-checkout-interruption__col">
      <span class="cart-guest-checkout-interruption__title">{{ $t('cart.interruptStep.checkoutAsGuest') }}</span>
      <span class="cart-guest-checkout-interruption__subtitle">{{ $t('cart.interruptStep.enterEmail') }}</span>
      <form class="cart-guest-checkout-interruption__form" @submit.prevent="onFormSubmit">
        <FormGroup
          v-model.trim="$v.form.email.$model.value"
          @input="onFieldChange(form.email)"
          :field="$v.form.email"
          :isValidationRun="isValidationRun"
        />
        <FormCheckbox
          class="cart-summary__terms"
          v-model="subscriptionCheckbox.value"
          :field="subscriptionCheckbox"
        />
        <button
          type="submit"
          :disabled="isLoading"
          class="cart-guest-checkout-interruption__submit button button--primary"
        >{{ $t('cart.interruptStep.continueAsGuest') }}</button>
      </form>

      <CountrySwitcher />
    </div>
    <loader v-if="!isInitialized" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { required, email } from 'vuelidate/lib/validators'
import FormValidationMixin from '@/mixins/FormValidationMixin'
import LoaderMixin from '@/mixins/LoaderMixin'
import FormGroup from '@/components/FormGroup'
import FormCheckbox from '@/components/FormCheckbox'
import CountrySwitcher from '@/components/CountrySwitcher'

export default {
  name: 'CartGuestCheckoutInterruption',
  components: {
    FormGroup,
    FormCheckbox,
    CountrySwitcher
  },
  mixins: [FormValidationMixin, LoaderMixin],
  computed: {
    ...mapState('cart', ['cartData', 'checkoutStatuses']),
    ...mapState('user', ['emailSubscriptionsData']),
    ...mapGetters('app', ['isUSSite']),
    ...mapGetters('user', ['isUserHasEmailSubscription'])
  },
  methods: {
    ...mapActions('app', ['doLogin', 'doSignup']),
    ...mapActions('cart', ['setGuestEmail']),
    ...mapActions('user', ['setEmailSubscriptionsData', 'updateEmailSubscriptionsData']),
    onLoginClick () {
      this.doLogin({ customPath: '/cart/shipping' })
    },
    handleUpdateEmailSubscriptionsData () {
      if (!this.isUserHasEmailSubscription && this.subscriptionCheckbox.value) {
        this.updateEmailSubscriptionsData({
          pageName: 'Cart | Hubbell Store',
          pageUri: `${window.location.origin}/cart/guest-login`,
          newProductAnnouncements: true,
          salesAndDiscounts: true
        })
      }
    },
    onFormSubmit () {
      if (this.cartData.customerUid && this.form.email.value === this.cartData.customerUid) {
        this.handleUpdateEmailSubscriptionsData()
        this.$emit('emailFormSubmitted')
      } else {
        this.withPresendRoutine(() => {
          this.withLoader(() => {
            return this.sendForm(this.setGuestEmail, encodeURIComponent(this.form.email.value))
              .then(() => {
                return this.isUSSite ? this.setEmailSubscriptionsData() : null
              }).then(() => {
                this.handleUpdateEmailSubscriptionsData()
                this.$emit('emailFormSubmitted')
              }).catch(() => {
                this.isValidationRun = true
              })
          })
        })
      }
    }
  },
  validations () {
    return {
      form: {
        email: {
          value: {
            required,
            email,
            server: this.server
          }
        }
      }
    }
  },
  async created () {
    this.pushDataToForm({ email: this.cartData.customerUid })
    if (this.cartData.customerUid) await this.setEmailSubscriptionsData()
    this.isInitialized = true
  },
  data () {
    return {
      isValidationRun: false,
      isInitialized: false,
      form: {
        email: {
          type: 'email',
          placeholder: this.$t('cart.interruptStep.emailPlaceholder'),
          title: 'email',
          value: '',
          errors: {
            required: this.$t('cart.interruptStep.emailRequiredError'),
            email: this.$t('cart.interruptStep.emailInvalidError')
          }
        }
      },
      subscriptionCheckbox: {
        title: 'subscriptionCheckbox',
        type: 'checkbox',
        label: this.$t('cart.interruptStep.subscriptionCheckbox'),
        variant: 'shadow',
        value: !!this.isUSSite
      }
    }
  }
}
</script>
